/* Pick Your Spot popup. Loaded from snippets/is-pick-your-spot.liquid. */
(function () {
  var root = document.getElementById('is-pys');
  if (!root) return;

  var DISMISS_MS = 14 * 24 * 60 * 60 * 1000;
  var HOLES = {
    top_shelf_blocker: 'BAR DOWN.',
    top_shelf_glove: 'BAR DOWN.',
    five_hole: 'FIVE HOLE.',
    low_blocker: 'LIGHT THE LAMP.',
    low_glove: 'LIGHT THE LAMP.'
  };
  var HOLE_LABELS = {
    top_shelf_blocker: 'TOP SHELF BLOCKER',
    top_shelf_glove: 'TOP SHELF GLOVE',
    five_hole: 'FIVE HOLE',
    low_blocker: 'LOW BLOCKER',
    low_glove: 'LOW GLOVE'
  };
  var REWARDS = {
    free_shipping: {
      label: 'FREE SHIPPING',
      fine: 'US standard shipping only, up to $7.95. One code per order. Expires in 14 days.'
    },
    '10_off': {
      label: '10% OFF',
      fine: 'One code per order. Expires in 14 days. Excludes Last Call final-sale items.'
    },
    '15_off': {
      label: '15% OFF',
      fine: 'One code per order. Expires in 14 days. Excludes Last Call final-sale items.'
    }
  };
  var ERRORS = {
    invalid_email: 'Enter a valid email.',
    invalid_phone: 'Enter a valid phone number.',
    consent_required: 'Tap TEXT ME to agree to texts.',
    rate_limited: 'Too many tries. Wait a bit and try again.',
    bot_failed: 'We could not confirm this signup. Try again.',
    paused: 'This offer is paused. Please try again later.',
    unavailable: 'Something went wrong. Try again in a minute.',
    email_first: 'Enter your email first.',
    turnstile_timeout: 'Something went wrong, try again'
  };

  var backdrop = root.querySelector('.is-pys__backdrop');
  var dialog = root.querySelector('.is-pys__dialog');
  var teaser = root.querySelector('.is-pys__teaser');
  var steps = Array.prototype.slice.call(root.querySelectorAll('.is-pys__step'));
  var mode = root.getAttribute('data-mode') === 'generic' ? 'generic' : (root.getAttribute('data-mode') === 'game' ? 'game' : 'off');
  var demo = root.getAttribute('data-demo') === 'true';
  var state = {
    email: '',
    reward: 'free_shipping',
    code: '',
    hole: 'top_shelf_blocker',
    open: false,
    busy: false,
    completed: false
  };
  var returnFocus = null;
  var triggersOn = false;
  var turnstileWidget = null;

  function $(sel, scope) {
    return (scope || root).querySelector(sel);
  }

  function storageGet(key) {
    try { return localStorage.getItem(key); } catch (e) { return null; }
  }
  function storageSet(key, value) {
    if (demo) return;
    try { localStorage.setItem(key, value); } catch (e) { /* private mode */ }
  }

  function dismissedRecently() {
    var raw = Number(storageGet('is_pys_dismissed_at') || 0);
    return raw > 0 && Date.now() - raw < DISMISS_MS;
  }

  function pathBlocked() {
    var path = location.pathname || '';
    return path === '/cart' || path.indexOf('/cart/') === 0 || path.indexOf('/checkout') === 0;
  }

  /* Same rule as productPageSuppressesAutoOpen in workers/pick-your-spot/src/storefront.ts */
  function productPageSuppressesAutoOpen(path, viewportWidth) {
    var pathOnly = String(path || '/').split('?')[0].split('#')[0];
    return /\/products\/[^/]+/.test(pathOnly) && viewportWidth < 750;
  }

  function viewportWidth() {
    return window.matchMedia('(max-width: 749px)').matches ? 749 : 750;
  }

  function markProductQuiet() {
    if (productPageSuppressesAutoOpen(location.pathname, viewportWidth())) {
      root.classList.add('is-pys--quiet');
    }
  }

  /* Same rule as signupShouldFallback in workers/pick-your-spot/src/storefront.ts */
  function signupShouldFallback(code) {
    return code === 'timeout' || code === 'network' || code === 'unavailable';
  }

  function showStep(name) {
    var active = null;
    steps.forEach(function (step) {
      var on = step.getAttribute('data-step') === name;
      step.hidden = !on;
      step.classList.toggle('is-active', on);
      if (on) active = step;
    });
    if (name === 'done' || name === 'g-done') {
      state.completed = true;
      storageSet('is_pys_completed', '1');
    }
    var heading = active && active.querySelector('h2');
    if (dialog && heading) {
      if (!heading.id) heading.id = 'is-pys-' + name + '-title';
      dialog.setAttribute('aria-labelledby', heading.id);
    }
    var field = active && active.querySelector('input');
    if (field) field.setAttribute('aria-invalid', 'false');
  }

  function setError(stepName, code) {
    var step = root.querySelector('[data-step="' + stepName + '"]');
    if (!step) return;
    var error = step.querySelector('[data-error]');
    if (!error) return;
    if (!code) {
      error.hidden = true;
      error.textContent = '';
      return;
    }
    error.hidden = false;
    error.textContent = ERRORS[code] || ERRORS.unavailable;
  }

  function exactCode(code) {
    return String(code || 'IS-XXXXXX').replace(/\s+/g, '');
  }

  function fillReveal() {
    var reward = REWARDS[state.reward] || REWARDS.free_shipping;
    var title = $('[data-reveal-title]');
    var spot = $('[data-reveal-spot]');
    var label = $('[data-reward-label]');
    var code = $('[data-code]');
    var fine = $('[data-fine]');
    var headline = HOLES[state.hole] || 'BAR DOWN.';
    if (title) {
      title.textContent = headline;
      title.classList.toggle('is-pys__title--long', headline.length > 12);
    }
    if (spot) spot.textContent = HOLE_LABELS[state.hole] || 'TOP SHELF BLOCKER';
    if (label) label.textContent = reward.label;
    if (code) {
      var minted = exactCode(state.code);
      code.textContent = minted;
      code.setAttribute('aria-label', 'Copy code ' + minted);
    }
    if (fine) fine.textContent = reward.fine;
  }

  function copyExactCode() {
    var value = exactCode(state.code);
    var box = $('[data-code]');
    var status = $('[data-copy-status]');
    if (box) box.textContent = value;
    function announce() {
      if (status) status.textContent = 'Copied';
    }
    function fallback() {
      var field = document.createElement('textarea');
      field.value = value;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.left = '-9999px';
      document.body.appendChild(field);
      field.select();
      try { document.execCommand('copy'); } catch (err) { /* clipboard blocked */ }
      document.body.removeChild(field);
      announce();
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(value).then(announce).catch(fallback);
      return;
    }
    fallback();
  }

  function openDialog(step) {
    if (state.completed && !demo) return;
    state.open = true;
    backdrop.hidden = false;
    document.body.classList.add('is-pys-lock');
    teaser.hidden = true;
    showStep(step || (mode === 'generic' ? 'g-email' : 'corners'));
    returnFocus = document.activeElement;
    var closeBtn = $('.is-pys__close');
    if (closeBtn) closeBtn.focus();
    trackView();
  }

  function closeDialog(opts) {
    opts = opts || {};
    state.open = false;
    backdrop.hidden = true;
    document.body.classList.remove('is-pys-lock');
    if (opts.complete) {
      state.completed = true;
      storageSet('is_pys_completed', '1');
      teaser.hidden = true;
    } else if (opts.dismiss) {
      storageSet('is_pys_dismissed_at', String(Date.now()));
      teaser.hidden = false;
    }
    var back = opts.dismiss && teaser && !teaser.hidden ? teaser : returnFocus;
    if (back && typeof back.focus === 'function') back.focus();
  }

  function dismiss() {
    if (root.getAttribute('data-design-mode') === 'true') {
      closeDialog();
      return;
    }
    var active = $('.is-pys__step.is-active');
    var step = active && active.getAttribute('data-step');
    if (state.completed || step === 'done' || step === 'g-done') {
      closeDialog({ complete: true });
      return;
    }
    closeDialog({ dismiss: true });
  }

  function finish() {
    closeDialog({ complete: true });
  }

  function focusables() {
    return Array.prototype.slice.call(dialog.querySelectorAll('button, a[href], input, [tabindex]:not([tabindex="-1"])')).filter(function (el) {
      if (el.disabled || el.getAttribute('aria-hidden') === 'true') return false;
      return !el.closest('[hidden]');
    });
  }

  function onKeydown(event) {
    if (backdrop.hidden) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      dismiss();
      return;
    }
    if (event.key !== 'Tab') return;
    var items = focusables();
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function validEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
  }

  function setBusy(form, busy) {
    state.busy = busy;
    if (!form) return;
    form.setAttribute('aria-busy', busy ? 'true' : 'false');
    var button = form.querySelector('.is-pys__btn');
    if (button) button.disabled = busy;
  }

  function loadTurnstile() {
    if (window.turnstile) return Promise.resolve();
    return new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      script.async = true;
      script.onload = function () { resolve(); };
      script.onerror = function () { reject(new Error('bot_failed')); };
      document.head.appendChild(script);
    });
  }

  function clearTurnstile() {
    if (turnstileWidget != null && window.turnstile && typeof window.turnstile.remove === 'function') {
      try { window.turnstile.remove(turnstileWidget); } catch (e) { /* already gone */ }
    }
    turnstileWidget = null;
  }

  function turnstileToken() {
    if (demo) return Promise.resolve('demo');
    var siteKey = root.getAttribute('data-turnstile-site-key') || '';
    if (!siteKey) return Promise.reject(assignCode(new Error('bot_failed'), 'bot_failed'));
    return new Promise(function (resolve, reject) {
      var settled = false;
      var timer = setTimeout(function () {
        fail(assignCode(new Error('turnstile_timeout'), 'turnstile_timeout'));
      }, 10000);
      function ok(token) {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        resolve(token);
      }
      function fail(error) {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        clearTurnstile();
        reject(error);
      }
      loadTurnstile().then(function () {
        if (settled || !window.turnstile) return;
        var holder = document.createElement('div');
        holder.hidden = true;
        dialog.appendChild(holder);
        clearTurnstile();
        /* Widget mode is set in the Cloudflare dashboard (Invisible). Do not pass size. */
        turnstileWidget = window.turnstile.render(holder, {
          sitekey: siteKey,
          callback: function (token) { ok(token); },
          'error-callback': function () { fail(assignCode(new Error('bot_failed'), 'bot_failed')); }
        });
      }).catch(function () {
        fail(assignCode(new Error('bot_failed'), 'bot_failed'));
      });
    });
  }

  function assignCode(error, code) {
    error.code = code;
    return error;
  }

  function mockApi(path, body) {
    if (path === '/v1/signup' && mode === 'game') {
      return Promise.resolve({
        ok: true,
        mode: 'game',
        reward: 'free_shipping',
        rewardLabel: 'FREE SHIPPING',
        code: 'IS-DEMO24',
        expires: new Date(Date.now() + 14 * 86400000).toISOString(),
        repeat: false
      });
    }
    if (path === '/v1/signup') return Promise.resolve({ ok: true, mode: 'generic' });
    return Promise.resolve({ ok: true, shoppingFor: body && body.shoppingFor });
  }

  function api(path, body) {
    if (demo) return mockApi(path, body);
    var base = root.getAttribute('data-worker-url') || '';
    if (!base) return Promise.reject(assignCode(new Error('unavailable'), 'unavailable'));
    return turnstileToken().then(function (token) {
      var controller = new AbortController();
      var timer = setTimeout(function () { controller.abort(); }, 5000);
      return fetch(base.replace(/\/$/, '') + path, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        signal: controller.signal,
        body: JSON.stringify({
          email: state.email || (body && body.email),
          phone: body && body.phone,
          consent: body && body.consent,
          shoppingFor: body && body.shoppingFor,
          mode: mode,
          country: root.getAttribute('data-country') || '',
          turnstileToken: token
        })
      }).then(function (response) {
        clearTimeout(timer);
        return response;
      }, function (error) {
        clearTimeout(timer);
        if (error && error.name === 'AbortError') throw assignCode(new Error('timeout'), 'timeout');
        throw assignCode(new Error('network'), 'network');
      });
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (data) {
        if (!response.ok || data.ok === false) {
          var code = data.error || 'unavailable';
          throw assignCode(new Error(code), code);
        }
        return data;
      });
    });
  }

  /* Same body as klaviyoClientSubscription in workers/pick-your-spot/src/storefront.ts */
  function klaviyoFallback(email) {
    var company = root.getAttribute('data-company') || '';
    var list = root.getAttribute('data-klaviyo-list') || '';
    if (!company || !list || !email) return Promise.resolve(false);
    var source = mode === 'generic' ? 'Latest Drops' : 'Pick Your Spot';
    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: source,
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: list } } }
      }
    };
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, 5000);
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
      method: 'POST',
      headers: { 'content-type': 'application/json', revision: '2026-10-15' },
      body: JSON.stringify(payload),
      signal: controller.signal
    }).then(function (res) { return res.ok; }).catch(function () { return false; }).finally(function () { clearTimeout(timer); });
  }

  function onEmail(event) {
    event.preventDefault();
    if (state.busy) return;
    var form = event.currentTarget;
    var input = form.querySelector('input[type="email"]');
    var step = form.getAttribute('data-form');
    var value = input ? input.value : '';
    if (!validEmail(value)) {
      setError(step, 'invalid_email');
      if (input) {
        input.setAttribute('aria-invalid', 'true');
        input.focus();
      }
      return;
    }
    setError(step, '');
    setBusy(form, true);
    state.email = value.trim();
    api('/v1/signup', { email: state.email }).then(function (data) {
      return data;
    }, function (error) {
      var code = (error && error.code) || 'unavailable';
      if (!signupShouldFallback(code)) throw error;
      return klaviyoFallback(state.email).then(function (ok) {
        if (!ok) throw error;
        return { fallback: true };
      });
    }).then(function (data) {
      if (data.fallback) {
        showStep('saved');
        state.completed = true;
        storageSet('is_pys_completed', '1');
        return;
      }
      if (mode === 'game' && data.mode !== 'game') throw assignCode(new Error('paused'), 'paused');
      if (data.mode === 'game') {
        state.reward = data.reward || 'free_shipping';
        state.code = data.code || '';
        fillReveal();
        shoot();
      } else {
        showStep('g-sms');
      }
    }).catch(function (error) {
      setError(step, (error && error.code) || 'unavailable');
    }).then(function () {
      setBusy(form, false);
    });
  }

  function onSms(event) {
    event.preventDefault();
    if (state.busy) return;
    var form = event.currentTarget;
    var step = form.getAttribute('data-form');
    var input = form.querySelector('input[type="tel"]');
    setError(step, '');
    setBusy(form, true);
    api('/v1/sms', { email: state.email, phone: input ? input.value : '', consent: true }).then(function () {
      showStep(step === 'g-sms' ? 'g-done' : 'who');
      if (step === 'g-sms') state.completed = true;
    }).catch(function (error) {
      var code = error.code || 'unavailable';
      /* The reward already exists by this step. A server-side failure should not stop the shopper,
         so move on as if they skipped. Input problems still show their message. */
      if (signupShouldFallback(code) || code === 'rate_limited' || code === 'bot_failed' || code === 'turnstile_timeout') {
        showStep(step === 'g-sms' ? 'g-done' : 'who');
        if (step === 'g-sms') {
          state.completed = true;
          storageSet('is_pys_completed', '1');
        }
        return;
      }
      setError(step, code);
    }).then(function () {
      setBusy(form, false);
    });
  }

  function skipSms(event) {
    var which = event.currentTarget.getAttribute('data-skip');
    if (which === 'generic') {
      showStep('g-done');
      storageSet('is_pys_completed', '1');
      state.completed = true;
      return;
    }
    showStep('who');
  }

  function placePuck(hole, animate) {
    var button = root.querySelector('[data-hole="' + hole + '"]');
    var rink = $('.is-pys__rink');
    var puck = $('.is-pys__puck');
    if (!button || !rink || !puck) return Promise.resolve();
    var oval = button.querySelector('.is-pys__oval');
    var rinkBox = rink.getBoundingClientRect();
    var ovalBox = (oval || button).getBoundingClientRect();
    var endX = ovalBox.left - rinkBox.left + ovalBox.width / 2;
    var endY = ovalBox.top - rinkBox.top + ovalBox.height / 2;
    var startX = rinkBox.width / 2;
    var startY = rinkBox.height * 0.78;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches || !animate;
    puck.hidden = false;
    puck.style.transform = 'translate(' + startX + 'px, ' + startY + 'px)';
    if (reduce) {
      puck.style.transform = 'translate(' + endX + 'px, ' + endY + 'px)';
      button.classList.add('is-hit');
      return Promise.resolve();
    }
    return new Promise(function (resolve) {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          var done = function () {
            puck.removeEventListener('transitionend', done);
            button.classList.add('is-hit');
            resolve();
          };
          puck.addEventListener('transitionend', done);
          puck.style.transform = 'translate(' + endX + 'px, ' + endY + 'px)';
          setTimeout(done, 700);
        });
      });
    });
  }

  function resetHoles() {
    Array.prototype.forEach.call(root.querySelectorAll('.is-pys__hole'), function (hole) {
      hole.disabled = false;
      hole.classList.remove('is-picked', 'is-hit');
    });
    var puck = $('.is-pys__puck');
    if (puck) puck.hidden = true;
  }

  /* Game order: pick a spot, then the email, then the shot. The spot only picks the headline. */
  function onHole(event) {
    if (state.busy) return;
    var button = event.currentTarget;
    resetHoles();
    state.hole = button.getAttribute('data-hole');
    button.classList.add('is-picked');
    var picked = $('[data-picked-spot]');
    if (picked) {
      picked.textContent = 'Your spot: ' + (HOLE_LABELS[state.hole] || 'Top shelf blocker');
      picked.hidden = false;
    }
    fillReveal();
    showStep('email');
    var field = $('[data-step="email"] input[type="email"]');
    if (field) field.focus();
  }

  function repick() {
    resetHoles();
    showStep('corners');
  }

  function shoot() {
    state.busy = true;
    root.classList.add('is-pys--shooting');
    showStep('corners');
    Array.prototype.forEach.call(root.querySelectorAll('.is-pys__hole'), function (hole) {
      hole.disabled = true;
      hole.classList.remove('is-picked');
    });
    placePuck(state.hole, true).then(function () {
      return new Promise(function (resolve) { setTimeout(resolve, 380); });
    }).then(function () {
      root.classList.remove('is-pys--shooting');
      showStep('reveal');
      state.busy = false;
      var next = $('[data-step="reveal"] .is-pys__btn');
      if (next) next.focus();
    });
  }

  function onWho(event) {
    if (state.busy) return;
    var value = event.currentTarget.getAttribute('data-shopping-for');
    setError('who', '');
    state.busy = true;
    function finishWho() {
      showStep('done');
      storageSet('is_pys_completed', '1');
      state.completed = true;
    }
    /* This answer is a nice-to-have. Never strand someone who already has their code. */
    api('/v1/shopping-for', { email: state.email, shoppingFor: value }).then(finishWho, finishWho).then(function () {
      state.busy = false;
    });
  }

  function skipWho() {
    showStep('done');
    storageSet('is_pys_completed', '1');
    state.completed = true;
  }

  function goSms() {
    showStep('sms');
  }

  function trackView() {
    try {
      window.klaviyo = window.klaviyo || [];
      if (typeof window.klaviyo.push === 'function') {
        window.klaviyo.push(['track', 'Pick Your Spot Viewed', { mode: mode }]);
      }
    } catch (e) { /* analytics is optional */ }
  }

  function cookieHasEmail() {
    var match = document.cookie.match(/(?:^|; )__kla_id=([^;]+)/);
    if (!match) return false;
    try {
      var data = JSON.parse(atob(decodeURIComponent(match[1])));
      return !!(data && data.$email);
    } catch (e) {
      return false;
    }
  }

  function knownProfile() {
    return new Promise(function (resolve) {
      var waited = 0;
      var timer = setInterval(function () {
        waited += 100;
        var klaviyo = window.klaviyo;
        if (klaviyo && typeof klaviyo.isIdentified === 'function') {
          clearInterval(timer);
          Promise.resolve(klaviyo.isIdentified()).then(function (yes) {
            resolve(!!yes || cookieHasEmail());
          }).catch(function () { resolve(cookieHasEmail()); });
          return;
        }
        if (waited >= 1200) {
          clearInterval(timer);
          resolve(cookieHasEmail());
        }
      }, 100);
    });
  }

  function readCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[1]) : '';
  }

  function abVariant() {
    if (root.getAttribute('data-ab') !== 'true') return 'pys';
    var existing = readCookie('is_pys_ab');
    if (existing === 'pys' || existing === 'klaviyo') return existing;
    var next = crypto.getRandomValues(new Uint8Array(1))[0] < 128 ? 'pys' : 'klaviyo';
    document.cookie = 'is_pys_ab=' + next + '; Max-Age=' + (30 * 86400) + '; Path=/; SameSite=Lax';
    return next;
  }

  function suppressKlaviyo() {
    if (root.getAttribute('data-ab') !== 'true') return;
    var formId = root.getAttribute('data-klaviyo-form') || '';
    if (!formId) return;
    var style = document.createElement('style');
    style.setAttribute('data-pys-klaviyo-hide', formId);
    style.textContent = '.klaviyo-form-' + formId + ',[data-testid="klaviyo-form-' + formId + '"]{display:none !important;}';
    document.head.appendChild(style);
    var observer = new MutationObserver(function () {
      if (!style.isConnected) document.head.appendChild(style);
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 5000);
  }

  function armTriggers() {
    if (triggersOn || state.completed) return;
    triggersOn = true;
    markProductQuiet();
    if (dismissedRecently() || productPageSuppressesAutoOpen(location.pathname, viewportWidth())) {
      teaser.hidden = false;
      return;
    }
    var opened = false;
    var openOnce = function () {
      if (opened || state.open) return;
      opened = true;
      openDialog();
    };
    if (root.getAttribute('data-design-mode') === 'true') {
      openOnce();
      return;
    }
    setTimeout(openOnce, 8000);
    var onScroll = function () {
      var doc = document.documentElement;
      var max = doc.scrollHeight - doc.clientHeight;
      if (max <= 0) return;
      if ((doc.scrollTop || document.body.scrollTop) / max >= 0.4) openOnce();
    };
    document.addEventListener('scroll', onScroll, { passive: true });
    if (window.matchMedia('(min-width: 860px) and (hover: hover)').matches) {
      document.addEventListener('mouseout', function (event) {
        if (event.clientY > 8 || event.relatedTarget) return;
        openOnce();
      });
    }
  }

  function show(opts) {
    opts = opts || {};
    state.reward = opts.reward || state.reward;
    state.code = opts.code || state.code || 'IS-XXXXXX';
    state.hole = opts.hole || state.hole;
    fillReveal();
    if (opts.teaser) {
      backdrop.hidden = true;
      teaser.hidden = false;
      root.setAttribute('data-ready', 'true');
      return;
    }
    openDialog(opts.step || 'email');
    if (opts.hit) {
      showStep('corners');
      placePuck(opts.hit, false).then(function () {
        root.setAttribute('data-ready', 'true');
      });
      return;
    }
    root.setAttribute('data-ready', 'true');
  }

  Array.prototype.forEach.call(root.querySelectorAll('[data-form="email"], [data-form="g-email"]'), function (form) {
    form.addEventListener('submit', onEmail);
  });
  Array.prototype.forEach.call(root.querySelectorAll('[data-form="sms"], [data-form="g-sms"]'), function (form) {
    form.addEventListener('submit', onSms);
  });
  Array.prototype.forEach.call(root.querySelectorAll('[data-skip]'), function (button) {
    button.addEventListener('click', skipSms);
  });
  Array.prototype.forEach.call(root.querySelectorAll('.is-pys__hole'), function (button) {
    button.addEventListener('click', onHole);
  });
  Array.prototype.forEach.call(root.querySelectorAll('[data-shopping-for]'), function (button) {
    button.addEventListener('click', onWho);
  });
  var skipWhoBtn = $('[data-skip-who]');
  if (skipWhoBtn) skipWhoBtn.addEventListener('click', skipWho);
  var toSms = $('[data-to-sms]');
  if (toSms) toSms.addEventListener('click', goSms);
  var repickBtn = $('[data-repick]');
  if (repickBtn) repickBtn.addEventListener('click', repick);
  var copyCode = $('[data-copy-code]');
  if (copyCode) copyCode.addEventListener('click', copyExactCode);
  var closeBtn = $('.is-pys__close');
  if (closeBtn) closeBtn.addEventListener('click', dismiss);
  if (teaser) teaser.addEventListener('click', function () { openDialog(); });
  backdrop.addEventListener('click', function (event) {
    if (event.target === backdrop) dismiss();
  });
  Array.prototype.forEach.call(root.querySelectorAll('[data-decline]'), function (button) {
    button.addEventListener('click', dismiss);
  });
  document.addEventListener('keydown', onKeydown);

  window.IronSteelPYS = { show: show };

  if (demo) {
    var params = new URLSearchParams(location.search);
    if (params.has('shot')) {
      var shot = params.get('shot');
      show({
        step: shot === 'shot' ? 'corners' : shot,
        hole: params.get('hole') || 'five_hole',
        reward: params.get('reward') || 'free_shipping',
        code: params.get('code') || 'IS-XXXXXX',
        teaser: shot === 'teaser',
        hit: shot === 'shot' ? (params.get('hole') || 'five_hole') : ''
      });
    } else {
      root.setAttribute('data-ready', 'true');
    }
    return;
  }

  loadMode().then(function (next) {
    if (next !== 'game' && next !== 'generic') return;
    mode = next;
    root.setAttribute('data-mode', mode);
    if (pathBlocked()) return;
    if (storageGet('is_pys_completed') === '1') return;
    if (abVariant() === 'klaviyo') return;
    if (root.getAttribute('data-ab') === 'true') suppressKlaviyo();
    knownProfile().then(function (known) {
      if (known) return;
      armTriggers();
    });
  });

  function loadMode() {
    var base = root.getAttribute('data-worker-url') || '';
    if (!base) return Promise.resolve('off');
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, 5000);
    return fetch(base.replace(/\/$/, '') + '/mode', { signal: controller.signal })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (data && (data.mode === 'game' || data.mode === 'generic' || data.mode === 'off')) return data.mode;
        return 'off';
      })
      .catch(function () { return 'off'; })
      .finally(function () { clearTimeout(timer); });
  }
})();
